import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Handshake, Building2, TrendingUp, ShieldCheck, FileText, Briefcase } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const operations = [{
  title: "Fusioni e Acquisizioni",
  description: "Assistenza strategica completa in operazioni di M&A, dalla due diligence alla chiusura del deal, garantendo la massima tutela degli interessi del cliente.",
  icon: Handshake
}, {
  title: "Joint Ventures",
  description: "Strutturazione di accordi di partnership commerciale e industriale, definendo governance e meccanismi di exit per collaborazioni solide e durature.",
  icon: Building2
}, {
  title: "Private Equity",
  description: "Consulenza legale per fondi di investimento e società target in operazioni di investimento, disinvestimento e leveraged buyout.",
  icon: TrendingUp
}, {
  title: "Ristrutturazioni Societarie",
  description: "Supporto nella riorganizzazione degli assetti societari, trasformazioni, scissioni e conferimenti per ottimizzare la struttura d'impresa.",
  icon: Briefcase
}, {
  title: "Governance e Compliance",
  description: "Definizione di modelli di governance efficienti e verifica della conformità normativa per prevenire rischi legali e operativi.",
  icon: ShieldCheck
}, {
  title: "Contrattualistica Straordinaria",
  description: "Redazione e negoziazione di contratti complessi legati a operazioni straordinarie, patti parasociali e accordi di investimento.",
  icon: FileText
}];
export default function ExtraordinaryOperations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="operazioni-straordinarie" ref={ref} className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/dark_leather_texture.png')] bg-cover bg-center opacity-20 mix-blend-overlay pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {}
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-serif font-medium tracking-tight mb-6 text-foreground">
            Operazioni Straordinarie
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Supportiamo le imprese nelle fasi cruciali di crescita e trasformazione con un approccio strategico, 
            integrando competenza legale e visione di business per operazioni complesse.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {operations.map((op, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full bg-white/5 border-white/10 backdrop-blur-md hover:bg-white/10 transition-colors duration-300 group">
                <CardHeader className="flex flex-col items-center text-center pt-10 pb-4">
                  <div className="mb-6 p-4 rounded-full bg-primary/10 ring-1 ring-primary/20 group-hover:ring-primary/40 transition-all duration-300">
                    <op.icon className="size-10 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-serif font-medium text-foreground">
                    {op.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center pb-10">
                  <CardDescription className="text-base text-muted-foreground/90 leading-relaxed">
                    {op.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div className={`text-center transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-8 py-6 h-auto rounded-full shadow-lg shadow-primary/10">
            <Link to="/ConsultingPage">
              Richiedi una Consulenza Strategica
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}